import React from 'react';
import Widget from '../common/Widget';
import universityLibrariesConfig from './config';
import LibraryContacts from './LibraryContacts';
import LibraryAccordion from './LibraryAccordion';

const UniversityLibraries = (props) => (
  <React.Fragment>
    <Widget
      data={{
        id: props.widget.id,
        title: props.title,
        isTitleStylized: props.isTitleStylized,
        isExpand: props.widget.isExpand,
        isRequired: props.widget.isRequired,
      }}
      className="myOdu__universityLibraries"
      {...props}
    >
      <LibraryContacts contacts={universityLibrariesConfig.contacts} />

      {universityLibrariesConfig.locations.map((location) => (
        <LibraryAccordion
          key={'universityLibraries__locationAccordion_' + location.title}
          iconPath={universityLibrariesConfig.iconPath}
          location={location}
        />
      ))}
    </Widget>
  </React.Fragment>
);

export default UniversityLibraries;
